import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        porcentaje: 0,
        contador: 0,
        usuario: '',
        contrasena: '',
        url: 'http://127.0.0.1/crudPortal/',
        datosC: [],
        cuestionario: [],
        preguntas: []
    },
    mutations: {
        setPorcentaje(state, dato) {
            state.porcentaje = dato;
        },
        setDatos(state, dato) {
            state.datosC = dato;
        },
        setCuestionario(state, dato) {
            state.cuestionario = dato;
        },
        setPreguntas(state, dato) {
            state.preguntas = dato;
        }
    },
    actions: {
        cargaInfo(context) {
            context.commit("setPorcentaje", 0);

            let datosG = new FormData();
            let total = 0;
            let porcentaje = 0;
            datosG.append("usuario", context.state.usuario);
            datosG.append("contrasena", context.state.contrasena);

            axios
                .post(context.state.url + "candidatos_posgrado.php", datosG)
                .then((res) => {
                    let datosP = res.data;
                    context.commit("setDatos", datosP[0]);

                    // console.log("Datos en el carga info");
                    // console.log(datosP[0]);

                    for (let index = 0; index < datosP.length; index++) {
                        const element = datosP[index];
                        for (const elemento in element) {
                            const valor = element[elemento];
                            if (elemento.indexOf("s_") == 0) {
                                total++;
                                if (valor >= 1) {
                                    porcentaje++;
                                }
                            }
                        }
                        porcentaje = (porcentaje * 100) / total;
                        porcentaje = Math.round(porcentaje);
                        // this.porcentaje = porcentaje;
                        context.commit("setPorcentaje", porcentaje);
                        console.log("en el index" + context.state.porcentaje);

                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        async cargaCuestionario(context) {

            let datosG = new FormData();
            datosG.append("usuario", context.state.usuario);
            datosG.append("contrasena", context.state.contrasena);

            try {
                let datos = await axios.post(
                    context.state.url + "candidatos_posgrado.php",
                    datosG
                );
                let cuestionario = Object
                    // console.log(datos.data[0]);
                    // console.log(JSON.parse(datos.data[0].cuestionario));

                // console.log("cuestionarii" + cuestionario);
                if (datos.data[0] !== undefined) {
                    // console.log("entro al if");
                    cuestionario = JSON.parse(datos.data[0].cuestionario)

                    // console.log(cuestionario);
                    // console.log(datos.data[0].cuestionario);
                    if (cuestionario != null) {
                        // console.log("en el respuesta cuestionario");
                        // console.log(cuestionario);
                        context.commit('setCuestionario', cuestionario);
                        context.commit('setPreguntas', cuestionario.preguntas);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        async imprimirPDF(context) {
            console.log("aqui");
            var algo = "";

            try {
                let datos = new FormData();
                let datosD = JSON.stringify(context.state.cuestionario);
                let datosCan = JSON.stringify(context.state.datosC);

                datos.append("datosD", datosD);
                datos.append("datosCandidato", datosCan);
                let x = await axios.post(context.state.url + "d_pdf.php", datos);
                algo = x.data;
                console.log(x.data);
            } catch (error) {
                console.log(error);
            }
            return algo;
        },
        descargarPDF(context) {
            let url = context.state.url +
                "./diagnostico/" + context.state.datosC.id_pros + "/Diagnostico" + context.state.datosC.id_pros + ".pdf";
            window.open(url, "Download");
        }
    },
    modules: {},
});